<template>
  <v-app>
    <v-main>
      <v-container fluid v-if="isTrue">
        <v-form class="mb-5">
          <v-row>
            <v-col cols="12" sm="6" md="4">
              <v-menu
                ref="menu"
                v-model="menu"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="dates"
                    label="Период"
                    append-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="dates"
                  range
                  locale="ru-RU"
                  :first-day-of-week="1"
                >
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="menu = false">
                    Отмена
                  </v-btn>
                  <v-btn text color="primary" @click="$refs.menu.save(dates)">
                    Сохранить
                  </v-btn>
                </v-date-picker>
              </v-menu>
            </v-col>
            <v-col>
              <v-select
                v-model="selectCompary"
                :items="comparyTypes"
                outlined
                label="Сравнивать"
              >
              </v-select>
            </v-col>
            <!--<v-col>
              <v-select
                v-model="selectCompany"
                :items="companys"
                outlined
                item-value="id"
                item-text="title"
                label="Юр. лицо"
                multiple
              >
              </v-select>
            </v-col>
            {{ selectCompany }}
            <v-col>
              <v-select
                v-model="selectTypeLists"
                :items="typesLists"
                outlined
                item-value="id"
                item-text="title"
                label="Тип выплат"
                multiple
              >
              </v-select>
            </v-col>-->
          </v-row>
          <v-row class="actions">
            <v-btn text color="blue" @click="getReport" :disabled="loading"
              >Сформировать</v-btn
            >
             <v-btn text color="green" @click="getXLS" :disabled="loading"
              >XLS</v-btn
            >
          </v-row>
        </v-form>
        <v-row v-show="headers.length > 0">
          <v-simple-table dense>
            <thead>
              <tr>
                <th>Статьи</th>
                <th
                  v-for="header in headers"
                  :key="header.id"
                  style="min-width: 200px; text-align: center"
                >
                  {{ header.title }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in reportItems" :key="index">
                <td>{{ item.title }}</td>
                <td
                  v-for="(header, indexHeader) in item.stats"
                  :key="`${index}-${indexHeader}`"
                >
                  <v-row>
                    <v-col>
                      <v-btn
                        text
                        icon
                        @click="header.menu = !header.menu"
                        v-show="!header.menu && header.items.length > 0"
                        >+</v-btn
                      >
                      <v-btn
                        text
                        icon
                        v-show="header.items.length == 0"
                        disabled
                      ></v-btn>
                      <v-btn
                        text
                        icon
                        @click="
                          header.menu = !header.menu && header.items.length > 0
                        "
                        v-show="header.menu"
                        >-</v-btn
                      >
                      <b>
                        {{
                          ` ${new Intl.NumberFormat("ru-RU", {
                            minimumFractionDigits: 2,
                          }).format(header.sum)} ${header.percent ? "| " : ""}`
                        }}
                      </b>
                      <b
                        v-show="header.percent"
                        :style="
                          header.percent > 0 ? 'color:#32CD32' : 'color:#FF4500'
                        "
                      >
                        {{ `${Math.ceil(header.percent) + "%"}` }}
                      </b>
                    </v-col>
                  </v-row>
                  <v-row
                    v-show="header.menu"
                    v-for="itemHeader in header.items"
                    :key="itemHeader.id"
                  >
                    <v-col cols="8">
                      <a :href="itemHeader.url" target="_blank">{{
                        itemHeader.title
                      }}</a>
                    </v-col>
                    <v-col>
                      {{
                        new Intl.NumberFormat("ru-RU", {
                          minimumFractionDigits: 2,
                        }).format(itemHeader.sum)
                      }}</v-col
                    >
                  </v-row>
                </td>
              </tr>
            </tbody>
            <thead>
              <tr>
                <th>Итог</th>
                <th
                  v-for="header in headers"
                  :key="header.id"
                  style="min-width: 200px; text-align: center"
                >
                  {{
                    new Intl.NumberFormat("ru-RU", {
                      minimumFractionDigits: 2,
                    }).format(sumInMounth[header.id].sum)
                  }}
                </th>
              </tr>
            </thead>
          </v-simple-table>
        </v-row>
      </v-container>
      <v-container v-else>
        <v-row>
          <v-col align-center>
            <h1 style="color: red">У вас нет доступа к отчету!</h1>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import axios from "axios";
import { BX24 } from "bx24";
import fileWrite from "file-saver";
import exeljs from "exceljs";

export default {
  name: "App",

  data: () => ({
    isTrue: true,
    menu: false,
    dateFormatted: [],
    loading: false,
    items: [],
    reportItems: [],
    companys: [],
    selectCompany: ["800"],
    clients: [],
    selectClient: "",
    sumInMounth: [],
    typesLists: [
      { title: "Счет на оплату", id: "18" },
      //{ title: "Счет KPI", id: "56" },
      //{ title: "Выдача наличных", id: "20" },
    ],
    selectTypeLists: ["18"],
    dates: [],
    normalDate: [],
    headers: [],
    selectCompary: "",
    comparyTypes: ["По дням", "По месяцам", "По годам"],
    stats: {},
    auth: {},
    url: "https://rentasnab.bitrix24.ru/rest/8/z0v2bq3x0pxb96pb/",
  }),
  methods: {
    async normalizeDate() {
      try {
        const firstDate = this.dates[0].split("-");
        const twoDate = this.dates[1].split("-");
        const firstDateFormated =
          firstDate[2] + "." + firstDate[1] + "." + firstDate[0] + " 00:00:00";
        const twoDateFormated =
          twoDate[2] + "." + twoDate[1] + "." + twoDate[0] + " 23:59:59";
        this.normalDate.push(firstDateFormated);
        this.normalDate.push(twoDateFormated);
      } catch (e) {
        console.log(e);
      }
    },
    async getFields() {
      try {
        //статьи расходов счета
        let id = 0;
        let isTrue = false;
        while (!isTrue) {
          const stats = await axios.post(this.url + "lists.element.get", {
            IBLOCK_TYPE_ID: "bitrix_processes",
            IBLOCK_ID: 72,
            start: -1,
            FILTER: {
              ">ID": id,
            },
          });
          console.log({ stats });
          if (stats.data.result.length == 0) {
            isTrue = true;
          } else {
            id = stats.data.result[stats.data.result.length - 1].ID;
            console.log({ id });
          }
          for (const stat of stats.data.result) this.stats[stat.ID] = stat.NAME;
        }
        console.log(this.stats, "stats");
        //плательщики
        const companyData = await axios.post(this.url + "lists.field.get", {
          IBLOCK_TYPE_ID: "bitrix_processes",
          IBLOCK_ID: 18,
          FIELD_ID: "PROPERTY_130",
        });
        for (const companyIndex in companyData.data.result.L
          .DISPLAY_VALUES_FORM) {
          this.companys.push({
            id: companyIndex,
            title: companyData.data.result.L.DISPLAY_VALUES_FORM[companyIndex],
          });
        }
        console.log(this.companys);
      } catch (error) {
        console.log({ error });
      }
    },
    async setItems(
      listsID,
      data,
      propertyDateID,
      propertyStatID,
      propertySumID,
      propertyCompnayID = null,
    ) {
      try {
        const propertyValue = (elem) => (elem ? Object.values(elem)[0] : "");
        for (const item of data) {
          let sum = 0;
          let sumItem = propertyValue(item[propertySumID]);
          console.log(sumItem);
          if (sumItem.includes("RUB")) {
            sum = sumItem.split("|")[0];
            console.log(sumItem, "has str");
          } else if (sumItem.includes(",")) {
            sum = sumItem.replace(",", ".");
          } else {
            sum = sumItem.replaceAll(" ", "");
          }
          this.items.push({
            id: item.ID,
            stat: item[propertyStatID]
              ? this.stats[propertyValue(item[propertyStatID])]
                ? this.stats[propertyValue(item[propertyStatID])]
                : propertyValue(item[propertyStatID])
              : "",
            sum: sum,
            company: propertyCompnayID
              ? propertyValue(item[propertyCompnayID])
              : "",
            datePay: propertyValue(item[propertyDateID]),
            title: item.NAME,
            url: `https://rentasnab.bitrix24.ru/bizproc/processes/${listsID}/element/0/${item.ID}/`,
          });
        }
        console.log(this.items);
      } catch (error) {
        console.log({ error });
      }
    },
    async getData() {
      try {
        this.reportItems = [];
        this.items = [];
        this.headers = [];
        this.normalDate = [];
        await this.normalizeDate();
        if (
          this.selectTypeLists.indexOf("18") > -1 ||
          this.selectTypeLists.length == 0
        ) {
          const invoices = await axios.post(
            "https://spa-bitrix.ru/rentasnab-report/getData.php",
            {
              id: "18",
              propertyDateID: "PROPERTY_68",
              propertyStatID: "PROPERTY_764",
              propertySumID: "PROPERTY_58",
              propertyCompnayID: "PROPERTY_130",
              propertyStatus: "PROPERTY_62",
              dateIn: this.normalDate[0],
              dateOf: this.normalDate[1],
              status: "56",
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          );
          await this.setItems(
            18,
            invoices.data,
            "PROPERTY_68",
            "PROPERTY_764",
            "PROPERTY_58",
            "PROPERTY_130",
          );
          console.log({ invoices });
        }
        if (
          this.selectTypeLists.indexOf("20") > -1 ||
          this.selectTypeLists.length == 0
        ) {
          const cashs = await axios.post(
            "https://spa-bitrix.ru/rentasnab-report/getData.php",
            {
              id: "20",
              propertyDateID: "PROPERTY_138",
              propertyStatID: "PROPERTY_772",
              propertySumID: "PROPERTY_164",
              propertyStatus: "PROPERTY_76",
              propertyCompnayID: "",
              dateIn: this.normalDate[0],
              dateOf: this.normalDate[1],
              status: "68",
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          );
          await this.setItems(
            20,
            cashs.data,
            "PROPERTY_138",
            "PROPERTY_772",
            "PROPERTY_164",
          );
          console.log({ cashs });
        }

        if (
          this.selectTypeLists.indexOf("56") > -1 ||
          this.selectTypeLists.length == 0
        ) {
          const kpi = await axios.post(
            "https://spa-bitrix.ru/rentasnab-report/getData.php",
            {
              id: "56",
              propertyDateID: "PROPERTY_534",
              propertyStatID: "PROPERTY_774",
              propertySumID: "PROPERTY_518",
              propertyStatus: "PROPERTY_524",
              propertyCompnayID: "PROPERTY_508",
              dateIn: this.normalDate[0],
              dateOf: this.normalDate[1],
              status: "520",
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          );
          await this.setItems(
            56,
            kpi.data,
            "PROPERTY_534",
            "PROPERTY_774",
            "PROPERTY_518",
            "PROPERTY_508",
          );
          console.log({ kpi });
        }
      } catch (error) {
        console.log({ error });
      }
    },
    async getReportInMonths() {
      try {
        this.loading = true;

        await this.getData();
        //по месяцам
        const stats = {};
        const headersTitle = {
          1: "Январь",
          2: "Февраль",
          3: "Март",
          4: "Апрель",
          5: "Май",
          6: "Июнь",
          7: "Июль",
          8: "Август",
          9: "Сентябрь",
          10: "Октябрь",
          11: "Ноябрь",
          12: "Декабрь",
        };
        for (const item of this.items) {
          let isTrue = true;
          if (this.selectCompany.length > 0) {
            const companys = [];
            for (const company of this.selectCompany) {
              companys.push(company);
              switch (company) {
                case "98":
                  companys.push("510");
                  break;
                case "100":
                  companys.push("512");
                  break;
                case "102":
                  companys.push("514");
                  break;
                case "104":
                  companys.push("516");
                  break;
                case "150":
                  companys.push("518");
                  break;
              }
            }
            console.log(this.selectCompany, "select");
            console.log({ companys });

            isTrue = false;
            console.log(item.company);
            const needCompnay = companys.filter((e) => e == item.company)[0];
            console.log({ needCompnay });
            if (needCompnay) isTrue = true;
          }
          console.log(item.datePay, "date pay");
          if (item.datePay && isTrue) {
            //формируем месяц и год
            const datePay = item.datePay.split(" ")[0];
            const formatDate = `${datePay.split(".")[2]}-${
              datePay.split(".")[1]
            }-${datePay.split(".")[0]}`;
            //  console.log({ formatDate });
            const date = new Date(formatDate);
            const isMonth = date.getMonth() + 1;
            const isYear = date.getFullYear();

            //Считаем итог по месяцу
            if (this.sumInMounth[isMonth]) {
              this.sumInMounth[isMonth].sum += Number(item.sum);
            } else {
              this.sumInMounth[isMonth] = {
                sum: Number(item.sum),
              };
            }
            //формируем массив статей
            //в массиме есть статья
            if (stats[item.stat]) {
              //если в статье уже есть месяц
              if (stats[item.stat][isMonth]) {
                stats[item.stat][isMonth].sum += Number(item.sum);
                stats[item.stat][isMonth].items.push(item);
              } else {
                //если в статье нет месяца
                stats[item.stat][isMonth] = {
                  sum: Number(item.sum),
                  percent: "",
                  company: item.company,
                  items: [item],
                  menu: false,
                };
                //проверяем в общем списке месяцев
                const needHeaders = this.headers.filter((e) => e.id == isMonth);
                //если месяца нет в общем списке, добавляем его туда
                if (needHeaders.length == 0) {
                  this.headers.push({
                    id: isMonth,
                    title: headersTitle[isMonth] + " " + isYear,
                    items: [],
                    menu: false,
                  });
                }
              }
            } else {
              //если статьи нет, добавляем статью
              stats[item.stat] = {};
              //добавляем месяц
              stats[item.stat][isMonth] = {
                sum: Number(item.sum),
                percent: "",
                company: item.company,
                items: [item],
                menu: false,
              };
            }
            //проверяем в общем списке месяцев
            const needHeaders = this.headers.filter((e) => e.id == isMonth);
            //если месяца нет в общем списке, добавляем его туда
            if (needHeaders.length == 0) {
              this.headers.push({
                id: isMonth,
                title: headersTitle[isMonth] + " " + isYear,
                items: [],
                menu: false,
              });
            }
          }
        }
        for (const header of this.headers) {
          for (const stat in stats) {
            if (typeof stats[stat][header.id] == "undefined") {
              stats[stat][header.id] = {
                sum: 0,
                percent: "",
                items: [],
                menu: false,
              };
            }
          }
        }
        for (const indexStat in stats) {
          for (const indexHeader in stats[indexStat]) {
            if (
              stats[indexStat][indexHeader] &&
              stats[indexStat][indexHeader - 1] &&
              stats[indexStat][indexHeader - 1].sum > 0
            ) {
              stats[indexStat][indexHeader].percent =
                Number(
                  Number(stats[indexStat][indexHeader].sum) /
                    Number(stats[indexStat][indexHeader - 1].sum),
                ) *
                  100 -
                100;
            } else {
              if (
                stats[indexStat][indexHeader] &&
                stats[indexStat][indexHeader - 1] &&
                stats[indexStat][indexHeader - 1].sum == 0
              ) {
                stats[indexStat][indexHeader].percent = 100;
              }
            }
          }
        }
        for (const indexStat in stats) {
          this.reportItems.push({
            title: indexStat,
            stats: stats[indexStat],
          });
        }
        this.loading = false;
      } catch (error) {
        console.log({ error });
      }
    },
    async getReportInYears() {
      try {
        this.loading = true;

        await this.getData();
        //по месяцам
        const stats = {};
        for (const item of this.items) {
          let isTrue = true;
          if (this.selectCompany.length > 0) {
            const companys = [];
            for (const company of this.selectCompany) {
              companys.push(company);
              switch (company) {
                case "98":
                  companys.push("510");
                  break;
                case "100":
                  companys.push("512");
                  break;
                case "102":
                  companys.push("514");
                  break;
                case "104":
                  companys.push("516");
                  break;
                case "150":
                  companys.push("518");
                  break;
              }
            }
            console.log(this.selectCompany, "select");
            console.log({ companys });

            isTrue = false;
            console.log(item.company);
            const needCompnay = companys.filter((e) => e == item.company)[0];
            console.log({ needCompnay });
            if (needCompnay) isTrue = true;
          }
          if (item.datePay && isTrue) {
            //формируем месяц и год
            const datePay = item.datePay.split(" ")[0];
            const formatDate = `${datePay.split(".")[2]}-${
              datePay.split(".")[1]
            }-${datePay.split(".")[0]}`;
            const date = new Date(formatDate);
            const isYear = date.getFullYear();

            if (this.sumInMounth[isYear]) {
              this.sumInMounth[isYear].sum += Number(item.sum);
            } else {
              this.sumInMounth[isYear] = {
                sum: Number(item.sum),
              };
            }
            //формируем массив статей
            //в массиме есть статья
            if (stats[item.stat]) {
              //если в статье уже есть год
              if (stats[item.stat][isYear]) {
                stats[item.stat][isYear].sum += Number(item.sum);
                stats[item.stat][isYear].items.push(item);
              } else {
                //если в статье нет года
                stats[item.stat][isYear] = {
                  sum: Number(item.sum),
                  percent: "",
                  company: item.company,
                  items: [item],
                  menu: false,
                };
                //проверяем в общем списке месяцев
                const needHeaders = this.headers.filter((e) => e.id == isYear);
                //если месяца нет в общем списке, добавляем его туда
                if (needHeaders.length == 0) {
                  this.headers.push({
                    id: isYear,
                    title: isYear,
                    items: [],
                    menu: false,
                  });
                }
              }
            } else {
              //если статьи нет, добавляем статью
              stats[item.stat] = {};
              //добавляем год
              stats[item.stat][isYear] = {
                sum: Number(item.sum),
                percent: 0,
                company: item.company,
                items: [item],
                menu: false,
              };
            }
            //проверяем в общем списке месяцев
            const needHeaders = this.headers.filter((e) => e.id == isYear);
            //если месяца нет в общем списке, добавляем его туда
            if (needHeaders.length == 0) {
              this.headers.push({
                id: isYear,
                title: isYear,
                items: [],
                menu: false,
              });
            }
          }
        }
        for (const header of this.headers) {
          for (const stat in stats) {
            if (typeof stats[stat][header.id] == "undefined") {
              stats[stat][header.id] = {
                sum: 0,
                percent: "",
                items: [],
                menu: false,
              };
            }
          }
        }
        for (const indexStat in stats) {
          for (const indexHeader in stats[indexStat]) {
            if (
              stats[indexStat][indexHeader] &&
              stats[indexStat][indexHeader - 1] &&
              stats[indexStat][indexHeader - 1].sum > 0
            ) {
              stats[indexStat][indexHeader].percent =
                Number(
                  Number(stats[indexStat][indexHeader].sum) /
                    Number(stats[indexStat][indexHeader - 1].sum),
                ) *
                  100 -
                100;
            } else {
              if (
                stats[indexStat][indexHeader] &&
                stats[indexStat][indexHeader - 1] &&
                stats[indexStat][indexHeader - 1].sum == 0
              ) {
                stats[indexStat][indexHeader].percent = 100;
              }
            }
          }
        }
        for (const indexStat in stats) {
          this.reportItems.push({
            title: indexStat,
            stats: stats[indexStat],
          });
        }
        this.loading = false;
      } catch (error) {
        console.log({ error });
      }
    },
    async getReportInDays() {
      try {
        this.loading = true;
        const formatDateChekOne = new Date(this.dates[0]);
        const formatDateChekTwo = new Date(this.dates[1]);
        if (formatDateChekTwo.getMonth() == formatDateChekOne.getMonth()) {
          await this.getData();
          //по дням
          const headersTitle = {
            1: "Январь",
            2: "Февраль",
            3: "Март",
            4: "Апрель",
            5: "Май",
            6: "Июнь",
            7: "Июль",
            8: "Август",
            9: "Сентябрь",
            10: "Октябрь",
            11: "Ноябрь",
            12: "Декабрь",
          };
          const stats = {};
          for (const item of this.items) {
            let isTrue = true;
            if (this.selectCompany.length > 0) {
              const companys = [];
              for (const company of this.selectCompany) {
                companys.push(company);
                switch (company) {
                  case "98":
                    companys.push("510");
                    break;
                  case "100":
                    companys.push("512");
                    break;
                  case "102":
                    companys.push("514");
                    break;
                  case "104":
                    companys.push("516");
                    break;
                  case "150":
                    companys.push("518");
                    break;
                }
              }
              console.log(this.selectCompany, "select");
              console.log({ companys });

              isTrue = false;
              console.log(item.company);
              const needCompnay = companys.filter((e) => e == item.company)[0];
              console.log({ needCompnay });
              if (needCompnay) isTrue = true;
            }
            if (item.datePay && isTrue) {
              //формируем месяц и день
              const datePay = item.datePay.split(" ")[0];
              const formatDate = `${datePay.split(".")[2]}-${
                datePay.split(".")[1]
              }-${datePay.split(".")[0]}`;
              const date = new Date(formatDate);
              const month = date.getMonth() + 1;
              const isDay = date.getDate();
              //формируем массив статей

              if (this.sumInMounth[isDay]) {
                this.sumInMounth[isDay].sum += Number(item.sum);
              } else {
                this.sumInMounth[isDay] = {
                  sum: Number(item.sum),
                };
              }
              //в массиме есть статья
              if (stats[item.stat]) {
                //если в статье уже есть месяц
                if (stats[item.stat][isDay]) {
                  stats[item.stat][isDay].sum += Number(item.sum);
                  stats[item.stat][isDay].items.push(item);
                } else {
                  stats[item.stat][isDay] = {
                    sum: Number(item.sum),
                    percent: "",
                    items: [item],
                    menu: false,
                  };

                  //проверяем в общем списке месяцев
                  const needHeaders = this.headers.filter((e) => e.id == isDay);
                  //если месяца нет в общем списке, добавляем его туда
                  if (needHeaders.length == 0) {
                    this.headers.push({
                      id: isDay,
                      title: `${headersTitle[month]}, ${isDay}`,
                      items: [],
                      menu: false,
                    });
                  }
                }
              } else {
                //если статьи нет, добавляем статью
                stats[item.stat] = {};
                //добавляем месяц
                stats[item.stat][isDay] = {
                  sum: Number(item.sum),
                  percent: "",
                  items: [item],
                  menu: false,
                };
              }
              //проверяем в общем списке месяцев
              const needHeaders = this.headers.filter((e) => e.id == isDay);
              //если месяца нет в общем списке, добавляем его туда
              if (needHeaders.length == 0) {
                this.headers.push({
                  id: isDay,
                  title: `${headersTitle[month]}, ${isDay}`,
                  items: [],
                  menu: false,
                });
              }
            }
          }
          for (const header of this.headers) {
            for (const stat in stats) {
              if (typeof stats[stat][header.id] == "undefined") {
                stats[stat][header.id] = {
                  sum: 0,
                  percent: "",
                  items: [],
                  menu: false,
                };
              }
            }
          }
          for (const indexStat in stats) {
            for (const indexHeader in stats[indexStat]) {
              if (
                stats[indexStat][indexHeader] &&
                stats[indexStat][indexHeader - 1] &&
                stats[indexStat][indexHeader - 1].sum > 0
              ) {
                stats[indexStat][indexHeader].percent =
                  Number(
                    Number(stats[indexStat][indexHeader].sum) /
                      Number(stats[indexStat][indexHeader - 1].sum),
                  ) *
                    100 -
                  100;
              } else {
                if (
                  stats[indexStat][indexHeader] &&
                  stats[indexStat][indexHeader - 1] &&
                  stats[indexStat][indexHeader - 1].sum == 0
                ) {
                  stats[indexStat][indexHeader].percent = 100;
                }
              }
            }
          }
          for (const indexStat in stats) {
            this.reportItems.push({
              title: indexStat,
              stats: stats[indexStat],
            });
          }
        } else {
          alert("В выбранном периоде должен быть только 1 месяц!");
        }
        this.loading = false;
      } catch (error) {
        console.log({ error });
      }
    },
    async getReport() {
      try {
        this.sumInMounth = [];
        if (this.dates.length > 0) {
          if (this.selectCompary) {
            switch (this.selectCompary) {
              case "По месяцам":
                await this.getReportInMonths();
                break;
              case "По годам":
                await this.getReportInYears();
                break;
              case "По дням":
                await this.getReportInDays();
                break;
            }
            this.reportItems.sort((a, b) => {
              if (a.title < b.title) {
                return -1;
              }
              if (a.title > b.title) {
                return 1;
              }
              return 0;
            });
            this.headers.sort((a, b) => {
              if (a.id < b.id) {
                return -1;
              }
              if (a.id > b.id) {
                return 1;
              }
              return 0;
            });
          } else {
            alert("Выберите, как сравнивать!");
          }
        } else {
          alert("Выберите период!");
        }
      } catch (error) {
        console.log({ error });
      }
    },
    async getXLS() {
      try {
        const workbook = new exeljs.Workbook();
        workbook.views = [
          {
            x: 0,
            y: 0,
            width: 29040,
            height: 15840,
            visibility: "visible",
          },
        ];
        const worksheet = workbook.addWorksheet("Отчет по статьям");

        // Создаем заголовки колонок
        const columns = [{ header: "Статьи", key: "title", width: 30 }];

        // Добавляем колонки для каждого периода (месяц/день/год)
        this.headers.forEach((header) => {
          columns.push({
            header: header.title,
            key: `header_${header.id}`,
            width: 20,
          });
        });

        worksheet.columns = columns;

        // Стили для заголовков
        const headerRow = worksheet.getRow(1);
        headerRow.font = { bold: true, size: 12, color: { argb: "FFFFFF" } };
        headerRow.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "4472C4" },
        };
        headerRow.alignment = { horizontal: "center", vertical: "middle" };
        headerRow.height = 30;

        // Добавляем данные
        for (const reportItem of this.reportItems) {
          const rowData = {
            title: reportItem.title,
          };

          // Добавляем суммы для каждого периода как числа
          this.headers.forEach((header) => {
            if (reportItem.stats[header.id]) {
              const stat = reportItem.stats[header.id];
              rowData[`header_${header.id}`] = Number(stat.sum);
            } else {
              rowData[`header_${header.id}`] = 0;
            }
          });

          const dataRow = worksheet.addRow(rowData);

          // Стилизация строки с данными
          dataRow.getCell(1).font = { bold: true };
          dataRow.getCell(1).fill = {
            type: "pattern",
            pattern: "solid",
            fgColor: { argb: "F2F2F2" },
          };

          // Стилизация ячеек с суммами и установка числового формата
          for (let i = 2; i <= this.headers.length + 1; i++) {
            const cell = dataRow.getCell(i);
            cell.numFmt = "#,##0.00"; // Числовой формат с разделителями тысяч и двумя знаками после запятой
            cell.alignment = { horizontal: "right" };
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };

            // Если есть процент, добавляем комментарий с процентом
            const headerId = this.headers[i - 2].id;
            if (
              reportItem.stats[headerId] &&
              reportItem.stats[headerId].percent
            ) {
              const percent = reportItem.stats[headerId].percent;
              cell.note = {
                texts: [
                  {
                    font: { size: 10, color: { argb: "000000" } },
                    text: `Изменение: ${Math.ceil(percent)}%`,
                  },
                ],
              };

              // Цветовое выделение в зависимости от знака процента
              if (percent > 0) {
                cell.font = { color: { argb: "32CD32" } };
              } else if (percent < 0) {
                cell.font = { color: { argb: "FF4500" } };
              }
            }
          }

          // Добавляем детальные строки, если есть items
          if (reportItem.stats) {
            for (const headerId in reportItem.stats) {
              const stat = reportItem.stats[headerId];
              if (stat.items && stat.items.length > 0) {
                for (const item of stat.items) {
                  const detailRowData = {
                    title: `  ${item.title}`,
                  };

                  // Добавляем сумму как число только в соответствующую колонку
                  const headerIndex = this.headers.findIndex(
                    (h) => h.id == headerId,
                  );
                  if (headerIndex !== -1) {
                    detailRowData[`header_${headerId}`] = Number(item.sum);
                  }

                  const detailRow = worksheet.addRow(detailRowData);

                  // Стилизация детальной строки
                  detailRow.getCell(1).font = { italic: true, size: 10 };
                  detailRow.getCell(1).fill = {
                    type: "pattern",
                    pattern: "solid",
                    fgColor: { argb: "FAFAFA" },
                  };

                  // Делаем ссылку кликабельной
                  if (item.url) {
                    detailRow.getCell(1).value = {
                      text: `  ${item.title}`,
                      hyperlink: item.url,
                    };
                    detailRow.getCell(1).font = {
                      color: { argb: "0563C1" },
                      underline: true,
                      italic: true,
                      size: 10,
                    };
                  }

                  // Форматирование числовых значений
                  if (headerIndex !== -1) {
                    const detailCell = detailRow.getCell(headerIndex + 2);
                    detailCell.numFmt = "#,##0.00";
                    detailCell.alignment = { horizontal: "right" };
                  }
                }
              }
            }
          }
        }

        // Добавляем строку с итогами
        const totalRowData = {
          title: "Итог",
        };

        this.headers.forEach((header) => {
          if (this.sumInMounth[header.id]) {
            totalRowData[`header_${header.id}`] = Number(
              this.sumInMounth[header.id].sum,
            );
          } else {
            totalRowData[`header_${header.id}`] = 0;
          }
        });

        const totalRow = worksheet.addRow(totalRowData);

        // Стилизация строки итогов
        totalRow.font = { bold: true, size: 12, color: { argb: "FFFFFF" } };
        totalRow.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "4472C4" },
        };

        for (let i = 1; i <= this.headers.length + 1; i++) {
          const cell = totalRow.getCell(i);
          cell.border = {
            top: { style: "medium" },
            left: { style: "thin" },
            bottom: { style: "medium" },
            right: { style: "thin" },
          };
          cell.alignment = { horizontal: i === 1 ? "left" : "right" };

          // Числовой формат для итоговых сумм
          if (i > 1) {
            cell.numFmt = "#,##0.00";
          }
        }

        // Применяем границы ко всем ячейкам с данными
        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber > 1) {
            row.eachCell((cell) => {
              if (!cell.border || Object.keys(cell.border).length === 0) {
                cell.border = {
                  top: { style: "thin" },
                  left: { style: "thin" },
                  bottom: { style: "thin" },
                  right: { style: "thin" },
                };
              }
            });
          }
        });

        // Автоподбор ширины колонок (приблизительно)
        worksheet.columns.forEach((column) => {
          column.width = column.width || 20;
        });

        // Генерируем и сохраняем файл
        const buffer = await workbook.xlsx.writeBuffer();
        const fileType =
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
        const blob = new Blob([buffer], { type: fileType });

        // Формируем имя файла с датами
        let fileName = "report";
        if (this.dates && this.dates.length === 2) {
          fileName += `_${this.dates[0]}_${this.dates[1]}`;
        }
        fileName += ".xlsx";

        fileWrite(blob, fileName);
      } catch (e) {
        console.log("Error generating XLS:", e);
        alert("Ошибка при формировании XLS файла");
      }
    },
  },
  async mounted() {
    this.isTrue = false;
    const bx24 = new BX24();
    this.auth = await bx24.getAuth();
    const url = `https://${this.auth.DOMAIN}/rest/`;
    const user = await axios.post(url + "profile", {
      auth: this.auth.ACCESS_TOKEN,
    });
    console.log({ user });
    if (
      user.data.result.ADMIN ||
      user.data.result.ID == 2036 ||
      user.data.result.ID == 60 ||
      user.data.result.ID == 88
    ) {
      this.isTrue = true;
    }

    console.log(this.isTrue);
    await this.getFields();
  },
};
</script>
